import { LotStatus } from '@rematter/frontend-lib-api-client';

import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableInventoryLot = QueryHookResult<
  typeof useInventoryLotsQuery
>[number];

export const useInventoryLotsQuery = createQueryHook(
  'shared.selectInventoryLot',
  (params: {
    searchTerm?: string;
    ids?: string[];
    facilityId?: string;
    status?: LotStatus[];
  }) => ({
    inventoryLots: {
      __args: {
        filter: {
          ids: params.ids,
          lotNumber: params.searchTerm,
          facilityId: params.facilityId,
          status: params.status ?? (['Active'] as LotStatus[]),
        },
        pagination: {
          offset: 0,
          limit: 20,
        },
      },
      entries: {
        id: true,
        lotNumber: true,
        facilityId: true,
        status: true,
        isToll: true,
        tollCustomerAccountId: true,
        quantitySummary: {
          itemId: true,
          quantity: {
            value: true,
            unit: true,
          },
        },
      },
    },
  }),
  {
    select: (data) => data.inventoryLots.entries ?? [],
  },
);

export const SelectInventoryLot = createEntityComboBox.remotelySearched(
  'SelectInventoryLot',
  useInventoryLotsQuery,
  {
    formatLabel: (entity) => entity.lotNumber,
    formatSubLabel: (entity) => {
      if (entity.quantitySummary && entity.quantitySummary.length > 0) {
        const summary = entity.quantitySummary[0];
        return `${summary.quantity.value} ${summary.quantity.unit}`;
      }
      return entity.isToll ? 'Toll' : '';
    },
  },
);
